import { createSelector } from 'reselect'

import { NAME } from './constants'
import { initialState } from './reducer'

export const stateSelector = state => state.get(NAME) || initialState
export default createSelector(stateSelector, state => state.toObject())



// WEBPACK FOOTER //
// ../source/views/PasswordReset/selectors.js